import { createAction, props } from '@ngrx/store';
import { DateRangeModel } from 'app/core/mips/common/models/date-range.model';

export const setExpenseDateRangeSelection = createAction('[DateRange] Set ExpenseDateRange', props<{ week: DateRangeModel }>());
export const clearExpenseDateRangeSelection = createAction('[DateRange] Clear ExpenseDateRange');